import { render, staticRenderFns } from "./DatosInstantenos.vue?vue&type=template&id=0a0615a7&scoped=true&"
import script from "./DatosInstantenos.vue?vue&type=script&lang=ts&"
export * from "./DatosInstantenos.vue?vue&type=script&lang=ts&"
import style0 from "./DatosInstantenos.vue?vue&type=style&index=0&id=0a0615a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0615a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0a0615a7', component.options)
    } else {
      api.reload('0a0615a7', component.options)
    }
    module.hot.accept("./DatosInstantenos.vue?vue&type=template&id=0a0615a7&scoped=true&", function () {
      api.rerender('0a0615a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Telemetria/DatosInstantaneos/DatosInstantenos.vue"
export default component.exports